import VideoCard from "./VideoCard";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ContentRail({ title, videos, href, testId }) {
  if (!videos || !videos.length) return null;
  return (
    <section className="mb-10" data-testid={testId}>
      <div className="flex items-end justify-between mb-4 px-1">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h2>
        {href && (
          <Link to={href} className="text-sm text-cyan-400 hover:text-cyan-300 flex items-center gap-1">
            See all <ChevronRight className="w-4 h-4" />
          </Link>
        )}
      </div>
      <div className="flex gap-4 overflow-x-auto pb-3 snap-x snap-mandatory hide-scrollbar -mx-4 px-4">
        {videos.map((v) => (
          <div key={v.id} className="snap-start"><VideoCard video={v} queue={videos} /></div>
        ))}
      </div>
    </section>
  );
}
